import { VersionInfoType } from "@/components/VersionInfo/VersionInfo";
import { defaultPublicApiClient } from "@/api/ApiClient";

export async function getAppVersions(): Promise<{buildInfos: VersionInfoType[]}> {
    return await  defaultPublicApiClient.httpGet<{buildInfos: VersionInfoType[]}>('/buildInfos');
}
